/** The tabs of the part search page, which `?tab` names. */
export const partLibrarySearchTabs = ['off-the-shelf', 'custom'] as const;

export type PartLibrarySearchTab = (typeof partLibrarySearchTabs)[number];
